import { Icon } from "@wisr/react-ui";
import React from "react";

import { BRAND_WEBSITE } from "../../shared/url.consts";
import globalStyle from "./application-layout.global.scss";
import localStyle from "./application-layout.scss";

export type LayoutType =
  | "vertical"
  | "multi-page-form"
  | "application-form"
  | "offer-page"
  | "offer-page-navy"
  | "post-submission-page"
  | "default";

interface GetHeaderContent {
  layoutType: LayoutType;
  setSupportModal?: (arg0: boolean) => void;
}

export const getHeaderContent = ({
  layoutType,
  setSupportModal,
}: GetHeaderContent) => {
  if (layoutType === "multi-page-form" || layoutType === "default") {
    return (
      <>
        <style jsx>{globalStyle}</style>
        <style jsx>{localStyle}</style>
        <div className="support-row">
          <p className="support-item">Need help?</p>
          <a className="support-item" href="tel:1300992007">
            <div className="icon">
              <Icon name="action-phone" size="md" legacy={false} />
            </div>{" "}
            1300 992 007
          </a>
          <a
            className="support-item"
            href={`${BRAND_WEBSITE}/contact-us?subject=Loans`}
            rel="noreferrer"
            target="_blank"
          >
            <div className="icon">
              <Icon name="action-email" size="md" legacy={false} />
            </div>{" "}
            Contact us
          </a>
          <a
            className="support-item"
            href={`${BRAND_WEBSITE}/help-categories/personal-loans`}
            rel="noreferrer"
            target="_blank"
          >
            <div className="icon">
              <Icon name="action-help" size="md" legacy={false} />
            </div>{" "}
            FAQs
          </a>
          {setSupportModal !== undefined ? (
            <a
              className="support-chat"
              rel="noreferrer"
              target="_blank"
              onClick={/* istanbul ignore next */ () => setSupportModal(true)}
            >
              <div className="icon">
                <Icon name="action-support-chat" size="md" legacy={false} />
              </div>
            </a>
          ) : (
            <a
              className="support-chat"
              href={`${BRAND_WEBSITE}/contact-us?subject=Loans`}
              rel="noreferrer"
              target="_blank"
            >
              <div className="icon">
                <Icon name="action-support-chat" size="md" legacy={false} />
              </div>
            </a>
          )}
        </div>
      </>
    );
  }
  return (
    <>
      <style jsx>{globalStyle}</style>
      <style jsx>{localStyle}</style>
      <div className="support-row offer-page-support-row">
        <p className="support-item">Need help?&nbsp;</p>
        <a className="support-item" href="tel:1300992007">
          1300 992 007
        </a>

        {setSupportModal !== undefined ? (
          <a
            className="support-chat"
            rel="noreferrer"
            target="_blank"
            onClick={/* istanbul ignore next */ () => setSupportModal(true)}
          >
            <div className="icon">
              <Icon name="action-support-chat" size="md" legacy={false} />
            </div>
          </a>
        ) : (
          <a
            className="support-chat"
            href={`${BRAND_WEBSITE}/contact-us?subject=Loans`}
            rel="noreferrer"
            target="_blank"
          >
            <div className="icon">
              <Icon name="action-support-chat" size="md" legacy={false} />
            </div>
          </a>
        )}
      </div>
    </>
  );
};
